
export const DeviceStatus = {
  IDLE: 'IDLE',
  OVER: 'OVER',
  JOG: 'JOG',
  SETTLING: 'SETTLING',
  PAUSE: 'PAUSE',
  FEED: 'FEED',
  DELAY: 'DELAY',
  WAIT_FEED: 'WAIT FEED',
  WAIT_DISCH: 'WAIT DISCH',
  WAIT_WATER: 'WAIT WATER',
  WAIT_ADMIX: 'WAIT ADMIX',
  WAIT_MOIST: 'WAIT MOIST',
  DISCH_DELAY: 'DISCH DELAY',
  DISCHARGING: 'DISCHARGING',
  TARE_ERROR: 'TARE ERROR',
  OPEN_ERROR: 'OPEN ERROR',
  METER_ERROR: 'METER ERROR',
  NOT_EMPTY: 'NOT EMPTY',
  HOLD: 'HOLD',
  MANUAL: 'MANUAL',
  FINISH: 'FINISH',
  CLOSE_DELAY: 'CLOSE DELAY',
  MIN_FLOW_RATE: 'MIN FLOW RATE',
  SKIP: 'SKIP',
  START_MIXING: 'START MIXING',
  MIXING: 'MIXING',
  END_MIXING: 'END MIXING',
  TOP_OPEN: 'TOP OPEN',
  RETURNING: 'RETURNING',
  CLOSING: 'CLOSING',
  SWITCHING: 'SWITCHING',
  LINE_CLEAR: 'LINE CLEAR',
  INDICATOR_ERROR: 'INDICATOR ERROR',
};
